function safeArray(value) {
  return Array.isArray(value)
    ? value
    : [];
}


function pageNumber(value) {
  const number = Number(value);

  return Number.isInteger(number) &&
    number > 0
    ? number
    : null;
}


function physicalPage({
  number,
  item = null,
  side = "",
  role = "",
}) {
  return {
    number,
    side,
    role,
    blank: !item,
    item,
  };
}


export function buildChildrensBookPublicationOpenBookViews(
  interiorItems = [],
  estimatedPageCount = 0
) {
  const items =
    safeArray(
      interiorItems
    );

  const byPage =
    new Map();

  let highestPage =
    Math.max(
      0,
      Number(
        estimatedPageCount
      ) || 0
    );

  for (const item of items) {
    const start =
      pageNumber(
        item?.pageStart
      );

    const end =
      pageNumber(
        item?.pageEnd
      ) || start;

    if (!start || !end) {
      continue;
    }

    highestPage =
      Math.max(
        highestPage,
        end
      );

    const spansTwoPages =
      end > start;

    if (spansTwoPages) {
      byPage.set(
        start,
        {
          item,
          role:
            "spread-left",
        }
      );

      byPage.set(
        end,
        {
          item,
          role:
            "spread-right",
        }
      );

      continue;
    }

    byPage.set(
      start,
      {
        item,
        role:
          "single",
      }
    );
  }

  if (highestPage < 1) {
    return [];
  }

  const views = [];

  /*
   * Page 1 is a recto/right-hand page.
   * The left side represents the inside-front-cover/
   * pre-page position and is intentionally blank.
   */
  views.push({
    id: "open-book-1",
    pageLabel: "Page 1",
    pageStart: 1,
    pageEnd: 1,
    left: physicalPage({
      number: null,
      side: "left",
      role:
        "pre-page-blank",
    }),
    right: physicalPage({
      number: 1,
      side: "right",
      ...(byPage.get(1) || {}),
    }),
  });

  for (
    let leftNumber = 2;
    leftNumber <= highestPage;
    leftNumber += 2
  ) {
    const rightNumber =
      leftNumber + 1;

    const leftEntry =
      byPage.get(
        leftNumber
      ) || null;

    const rightEntry =
      rightNumber <=
      highestPage
        ? (
            byPage.get(
              rightNumber
            ) || null
          )
        : null;

    views.push({
      id:
        `open-book-${leftNumber}-${rightNumber}`,
      pageLabel:
        rightNumber <=
        highestPage
          ? `Pages ${leftNumber}–${rightNumber}`
          : `Page ${leftNumber}`,
      pageStart:
        leftNumber,
      pageEnd:
        Math.min(
          rightNumber,
          highestPage
        ),
      left: physicalPage({
        number:
          leftNumber,
        side: "left",
        ...(leftEntry || {}),
      }),
      right:
        rightNumber <=
        highestPage
          ? physicalPage({
              number:
                rightNumber,
              side:
                "right",
              ...(rightEntry || {}),
            })
          : physicalPage({
              number: null,
              side:
                "right",
              role:
                "post-page-blank",
            }),
    });
  }

  return views;
}


export default
  buildChildrensBookPublicationOpenBookViews;
